import { apiUrl } from "../../../setting";
export const getProductReportUrl = ()=>{
    return `${apiUrl}/routes/dailyreport/findDailyProductStockReport`;
}